module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view__tabs"
  }, [_c('ul', {
    staticClass: "view__tabs--menu"
  }, [_c('li', {
    class: _vm.getCssClass('campaign-template')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'campaign-template',
        params: _vm.params
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.L.localize("Campaigns_Breadcrumb_Template")) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('campaign-code')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'campaign-code',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize("Campaigns_Breadcrumb_Code")) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('campaign')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'campaign',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize("Settings_Breadcrumb_Index")) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.getCssClass('campaign-preview')
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'campaign-preview',
        params: _vm.params
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.L.localize("Campaigns_Breadcrumb_Preview")) + "\n            ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-127794f6!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/templates/Submenu.vue
// module id = 708
// module chunks = 1